import React, { useEffect, useRef } from "react";
import { Button, notification } from "antd";
import { fetchAppVersion, getVersionFingerprint } from "../util/appVersion";

const POLL_INTERVAL_MS = 5 * 60 * 1000;
const NOTIFICATION_KEY = "app-version-update";

function VersionMonitor() {
  const baselineRef = useRef(null);
  const notifiedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const showUpdateNotification = (remote) => {
      notification.warning({
        key: NOTIFICATION_KEY,
        message: "New version available",
        description: `Version ${remote.version} (${remote.gitBuildVersion}) is ready. Please refresh your browser to update.`,
        duration: 0,
        placement: "bottomRight",
        btn: (
          <Button type="primary" size="small" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        ),
      });
    };

    const checkVersion = async () => {
      try {
        const remote = await fetchAppVersion();
        if (cancelled) return;

        const fingerprint = getVersionFingerprint(remote);

        if (baselineRef.current === null) {
          baselineRef.current = fingerprint;
          console.log("[VersionMonitor] Current version:", remote);
          return;
        }

        if (fingerprint !== baselineRef.current && !notifiedRef.current) {
          notifiedRef.current = true;
          showUpdateNotification(remote);
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.warn("[VersionMonitor]", error);
        }
      }
    };

    checkVersion();
    // const intervalId = setInterval(checkVersion, POLL_INTERVAL_MS);

    // return () => {
    //   cancelled = true;
    //   clearInterval(intervalId);
    // };
  }, []);

  return null;
}

export default VersionMonitor;
